





















import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { useContributionUploadedFileStore } from "@/employer/store/contributionUploadedFile";

@Component
export default class HowItWorksWidget extends Vue {
  contributionUploadedFileStore = useContributionUploadedFileStore();

  @Prop()
  modalName: string;

  @Prop()
  hideLearnMore: boolean;

  toggleHowItWorks (): void {
    const currentValue = !this.contributionUploadedFileStore.showHowItWorks;
    this.contributionUploadedFileStore.setShowHowItWorks(currentValue);
  }

  toggleModal (): void {
    this.$root.$emit("bv::toggle::modal", this.modalName, "#modal-toggle");
  }
}

